const enums = {
    ACCOUNT_PAIR: 'account-pair',
    ADMIN_ACCOUNT_PAIR: 'admin-account-pair',
    MERGE_ACCOUNTS: 'merge-accounts',
};

export default Object.freeze(enums);